import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { useAuth } from '../components/authProvider';

// Our Routes
import { ProtectedRoute } from './ProtectedRoute';

// Our Pages
import Login from '../pages/login';
import Appliances from '../pages/appliances';
import Compteur from '../pages/compteur';
import Emission from '../pages/emissions';
import Usage from '../pages/usage';
import Dashboard from '../pages/dashboard';
import Users from '../pages/users';
import Cost from '../pages/cost';
import Landing from '../pages/landing';
import Contact from '../pages/contact';

const Routes = () => {
  const { token } = useAuth();

  console.log({ routerToken: token });

  // Define public routes accessible to all users
  const routesForPublic = [
    {
      path: '/about-us',
      element: <div>About Us</div>,
    },
    {
      path: '/login',
      element: <Login />,
    },
    {
      path: '/landing',
      element: <Landing />,
    },
  ];

  // Define routes accessible only to authenticated users
  const routesForAuthenticatedOnly = [
    {
      path: '/',
      element: <ProtectedRoute />, // Wrap the component in ProtectedRoute
      children: [
        {
          path: '/',
          element: <Dashboard />,
        },
        {
          path: '/profile',
          element: <div>User Profile</div>,
        },
        {
          path: '/cost',
          element: <Cost />,
        },
        {
          path: '/users',
          element: <Users />,
        },
        {
          path: '/compteur',
          element: <Compteur />,
        },
        {
          path: '/emissions',
          element: <Emission />,
        },
        {
          path: '/usage-by-department',
          element: <Usage />,
        },
        {
          path: '/appliances',
          element: <Appliances />,
        },
        {
          path: '/contact',
          element: <Contact />,
        },
        
      ],
    },
  ];

  // Define routes accessible only to non-authenticated users
  const routesForNotAuthenticatedOnly = [
    {
      path: '/',
      element: <Landing />,
    },
    {
      path: '/login',
      element: <Login />,
    },
  ];

  // Combine and conditionally include routes based on authentication status
  const router = createBrowserRouter([
    ...routesForPublic,
    ...(!token ? routesForNotAuthenticatedOnly : []),
    ...routesForAuthenticatedOnly,
  ]);

  console.log({
    routers: [
      ...routesForPublic,
      ...(!token ? routesForNotAuthenticatedOnly : []),
      ...routesForAuthenticatedOnly,
    ],
  });

  // Provide the router configuration using RouterProvider
  return <RouterProvider router={router} />;
};

export default Routes;
